import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import TabBar from "rc-tabs/lib/TabBar";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import { ResumenConsumoProdTab } from "../../tabs/ResumenConsumoProdTab";
import { ReporteCierresMensualesTab } from "../../tabs/ReporteCierresMensualesTab";
import "../../styles/ReportesProduccion.css";

const TABS = ["RESUMEN_CONSUMO", "CIERRES_MENSUALES"];

class ReportesProduccion extends Component {
    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);
        let tabFromUrl = params.get("tab");

        // significa que fue carga nueva, por lo tanto no se conserva el estado anterior de filtros y página
        if (!tabFromUrl) {
            sessionStorage.removeItem("reporte_resumen_consumo_prod");
            sessionStorage.removeItem("reporte_cierres_mensuales_prod");
            sessionStorage.removeItem("reporte_cierres_mensuales_prod_tipo");
        }

        // sin pestaña, o con una que ya no existe, se abre la primera
        if (!TABS.includes(tabFromUrl)) {
            tabFromUrl = TABS[0];

            params.set("tab", tabFromUrl);

            this.props.history.replace({
                search: params.toString(),
            });
        }

        this.state = {
            tab: tabFromUrl,
        };
    }

    handleChangeTab = (tab) => {
        this.setState({ tab });

        const params = new URLSearchParams(this.props.location.search);
        params.set("tab", tab);

        this.props.history.replace({
            search: params.toString(),
        });
    };

    render() {
        return (
            <div
                className="mb-4 col-12"
                style={{ maxWidth: "91.5vw", margin: "auto" }}
            >
                <Card
                    icon="produccion_activo"
                    titulo="REPORTES DE PRODUCCIÓN"
                    subtitulo=""
                    noBorder
                >
                    <Tabs
                        activeKey={this.state.tab}
                        tabBarPosition="top"
                        onChange={this.handleChangeTab}
                        renderTabBar={() => <TabBar />}
                        renderTabContent={() => <TabContent animated={false} />}
                    >
                        <TabPane
                            tab="Resumen de consumo"
                            key="RESUMEN_CONSUMO"
                        >
                            <ResumenConsumoProdTab />
                        </TabPane>

                        <TabPane
                            tab="Cierres mensuales"
                            key="CIERRES_MENSUALES"
                        >
                            <ReporteCierresMensualesTab />
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        );
    }
}

export default ReportesProduccion;
